import {useEffect, useState, useRef} from 'react'
import { useNavigate } from 'react-router-dom';
import PageApp from '../../../Page';
import ModalEdit from './AddEdit'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Tag} from 'antd';
import {getAll, drop} from '../../../../apis/AcomuladoApi';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catálogos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Conceptos Acumulados</span>
      </>
    ),
}];

const ConceptoAcomulado = () => {
    let navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [objectSelected, setobjectSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    
    const columns = [
      {
        title: 'Clave',
        dataIndex: 'concepto.clave',
        key: 'concepto.clave',
        render: (item, object)=> {
          return <Space>
            <span>{object.concepto.clave}</span>
          </Space>
        }
      },
      {
        title: 'Descripcion',
        dataIndex: 'concepto.descripcion',
        key: 'concepto.descripcion',
        render: (item, object)=> {
          return <Space>
            <span>{object.concepto.descripcion}</span>
          </Space>
        }
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
            <Button type='primary' size='small' onClick={()=>{
                openDetails(object);
            }}>Editar</Button>
            <Button type='primary' size='small' danger onClick={()=>{
                deleteConfirm(object);
            }}>Eliminar</Button>
          </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      return navigate("../concepto_acomulado/" + object.id);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el concepto?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('¡El concepto ha sido eliminadó!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      return navigate("../concepto_acomulado/-1");
    }

    const onHandlerFinish = async (refresh) => {
      setOpenEdit(false);
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }

      setLoading(false);
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    return <PageApp routes={routes}
      title={'Acumulados'} 
      cardTitle='Lista de acumulados'
      extraCard={[
        <Button type="primary" onClick={btnClick}>
          Agregar Concepto Acumulado
        </Button>
      ]}>
      {
          loading ? (
            <p>Loading...</p>
          ) : <>
            {
              items.length == 0 ? <Empty />:
              <Table dataSource={items} columns={columns} />
            }
          </>
      }
      {
        (openEdit && objectSelected && objectSelected.id > 0) &&
        <ModalEdit title={"Editar Concepto"} id={objectSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !objectSelected) &&
        <ModalEdit title={"Crear Concepto"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default ConceptoAcomulado;
